:host {
  --pl-hero-height: clamp(42vh, 32rem, 26rem);
  --pl-hero-heading-font: var(--pl-font-serif);
  --pl-hero-color: var(--pl-color-fg-on-emphasis);
}

*, *:before, *:after {
  box-sizing: inherit;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.viewport-margins {
  width: 100%;
  max-width: var(--pl-viewport-margins-max-width);
  margin: 0 auto;
  padding: 0 var(--pl-viewport-margins-gutter, 1em);
}

/* Start of Selection */
/* Hero section */
.hero {
  position: relative;
  min-height: var(--pl-hero-height);
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 33%;
  display: flex;
}
/* End of Selection */

.hero::before {
  content: "";
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 20%, rgba(0, 0, 0, 0.4) 40%, rgba(0, 0, 0, 0.05) 100%);
  z-index: 0;
}

  
.hero::after {
  content: "";
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  background: linear-gradient(180deg, rgba(1, 31, 91, 1) 0%, rgba(1, 31, 91, 0.9) 10%, rgba(1, 31, 91, 0.8) 20%, rgba(1, 31, 91, 0.1) 50%, rgba(1, 31, 91, 0.0) 100%);
  z-index: 0;
}

.hero__content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;
}

.hero__heading-container {
  margin-top: auto;
  padding-top: var(--pl-space-3xl);
  padding-bottom: var(--pl-space-3xl);
}

.hero__heading {
  text-shadow: 1px 1px 2px var(--pl-color-fg-default);
  line-height: 1.1;
  font-size: 3em;
  font-weight: bold;
  font-family: var(--pl-hero-heading-font);
  text-wrap: pretty;
  max-width: 30ch;
  margin: 0;
  color: var(--pl-hero-color);
}

@media (max-width: 920px) {
  .hero__heading {
    font-size: 2.5em;
  }
}

.hero__sub-heading {
  font-size: 1.25em;
  font-family: var(--pl-font-family);
  font-weight: 500;
  color: var(--pl-hero-color);
  max-width: 52ch;
  text-wrap: pretty;
  margin-top: 1em;
  margin-bottom: 0;
}

.hero__sub-heading a {
  text-decoration: underline;
  text-underline-offset: var(--pl-link-text-underline-offset);
  text-decoration-thickness: var(--pl-link-text-decoration-thickness);
  color: var(--pl-hero-color);
}

.hero__sub-heading a:hover {
  text-decoration-thickness: var(--pl-link-hover-text-decoration-thickness);
}

.hero__sub-heading strong {
  font-weight: bold;
}

@media (max-width: 620px) {
  .hero__heading {
    font-size: 2.75em;
  }

  .hero__sub-heading {
    font-size: 1em;
  }
}